import storage from '../storage';

export default {
  namespaced: true,
  state: {
    token: '',
    redirectAfterLoginPath: '',
    currentPath: '',
    profile: {
      name: '',
      personId: '',
      email: '',
      phone: '',
      unreadNotificationCount: '',
      acceptsNewsletter: false,
      subscriptionEmail: '',
      confirmationEmail: '',
    },
  },
  getters: {
    isLoggedIn(state) {
      return !!state.profile.personId;
    },
    userId(state) {
      return state.profile.personId;
    },
  },
  mutations: {
    updateProfile(state, profile) {
      Object.assign(state.profile, profile);
    },

    clearProfile(state) {
      Object.keys(state.profile).forEach((key) => {
        state.profile[key] = '';
      });
    },

    redirectAfterLogin(state, path) {
      state.redirectAfterLoginPath = path;
    },

    setCurrentPath(state, path) {
      state.currentPath = path;
    },

    setToken(state, token) {
      state.token = token;
    },
  },
  actions: {
    loginByToken({ commit, dispatch }, accessToken) {
      commit('setToken', accessToken);
      dispatch('product/reloadProducts', null, { root: true });
      return dispatch('getUserInfo');
    },

    logout({ commit, dispatch, rootGetters }) {
      commit('setToken', '');
      commit('clearProfile');
      commit('purchase/setProduct', null, { root: true });
      commit('product/setMonitoringSettings', {}, { root: true });
      dispatch('product/reloadProducts', null, { root: true });
      storage.removeItem('vuex');

      return rootGetters.router.push({ name: `home-${rootGetters.locale}`, params: { lang: rootGetters.locale } });
    },

    expired({ dispatch }) {
      return dispatch('logout');
    },

    updateProfile({ commit, rootGetters }, details) {
      return rootGetters.api.patch('/user', details)
        .then(() => commit('updateProfile', details));
    },

    acceptSiteAgreement({ rootGetters }, params) {
      return rootGetters.api.post('/user/agreement', params)
        .then((response) => response.data);
    },
    getUserInfo({ commit, rootGetters }) {
      return rootGetters.api.get('/user')
        .then((response) => {
          commit('updateProfile', response.data);
          return response.data;
        })
        .catch((error) => {
          commit('setToken', '');
          if (error.response.status === 401) {
            return rootGetters.router.push(
              { name: `login-${rootGetters.locale}`, params: { lang: rootGetters.locale } }
            );
          } else {
            return Promise.reject(error);
          }
        });
    },
  },
};
